var _defs, _circle, _circle2, _path, _circle3, _path2, _path3, _line, _circle4, _path4, _circle5, _circle6, _line2, _line3, _path5, _line4, _line5, _line6, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _polygon2, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4bc190;}.cls-13,.cls-2{fill:#356cb6;}.cls-2{opacity:0.3;}.cls-3{fill:#393c54;}.cls-4{fill:#fba875;}.cls-5{fill:#ffffff;}.cls-12,.cls-6,.cls-8,.cls-9{fill:none;stroke-linecap:round;}.cls-6,.cls-9{stroke:#fba875;}.cls-12,.cls-6,.cls-9{stroke-miterlimit:10;}.cls-6{stroke-width:20px;}.cls-7{fill:#ffbb94;}.cls-8{stroke:#515570;stroke-linejoin:round;stroke-width:2px;opacity:0.4;}.cls-9{stroke-width:4px;}.cls-10{fill:#f85565;}.cls-11{fill:#515570;}.cls-12{stroke:#ffffff;stroke-width:3.28px;}.cls-12,.cls-13{opacity:0.1;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.08,61.57V45.92a32.92,32.92,0,0,1,65.84,0V61.57Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 91.32,
    cy: 60.43,
    r: 7.93
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,124.1a59.78,59.78,0,0,0,40-15.28l-2.39-5.68c-1.71-4-6.22-6.64-11.29-6.64H37.69c-5.07,0-9.58,2.66-11.29,6.64L24,108.82A59.78,59.78,0,0,0,64,124.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.72,98.25a3.06,3.06,0,0,0-3.08-2.88H49.36a3.07,3.07,0,0,0-3.08,2.93c0,.11,0,.21,0,.32-.17,7.32,10.52,16.64,10.52,16.64L64,108.05l7.17,7.17s10.56-9,10.56-16.22C81.73,98.74,81.73,98.49,81.72,98.25Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 64,
    x2: 64,
    y1: 84.75,
    y2: 98.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 36.68,
    cy: 60.43,
    r: 7.93
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64,94.37A28.31,28.31,0,0,1,35.68,66.05V47.43a28.32,28.32,0,1,1,56.64,0V66.05A28.31,28.31,0,0,1,64,94.37Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 76.67,
    cy: 59.28,
    r: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 49.67,
    cy: 59.28,
    r: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 74.39,
    x2: 84,
    y1: 53,
    y2: 52.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 53,
    x2: 43.39,
    y1: 53,
    y2: 52.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.55,74a1,1,0,0,1,.94,1.07,8.56,8.56,0,0,1-17,0A1,1,0,0,1,56.45,74Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 60,
    x2: 68,
    y1: 86,
    y2: 86
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 63.35,
    x2: 63.35,
    y1: 60.75,
    y2: 67.25
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 66,
    x2: 61,
    y1: 68,
    y2: 68
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M59,80.91a8.52,8.52,0,0,0,10.08,0,5.79,5.79,0,0,0-10.08,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69,76H59a1.84,1.84,0,0,1-1.73-2H70.77A1.84,1.84,0,0,1,69,76Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64,16.85a30,30,0,0,0-30,30V53a4,4,0,0,0,4-4V41.56a4.18,4.18,0,0,1,4.18-4.18h7.36A20.61,20.61,0,0,0,64,42.77a20.61,20.61,0,0,0,14.41-5.39h7.36A4.18,4.18,0,0,1,90,41.56v7.35a4,4,0,0,0,4,4V46.84A30,30,0,0,0,64,16.85Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.16,123.86c1.27.08,2.55.14,3.84.14s2.57-.06,3.84-.14L67,115H61Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M52.19,31.87A16.93,16.93,0,0,0,64,36.29a16.93,16.93,0,0,0,11.81-4.42h7.58"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64.58,117.22H63.26a4.58,4.58,0,0,1-4.58-4.58V108H69.17v4.64A4.58,4.58,0,0,1,64.58,117.22Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "64 108 74.17 95.38 78.64 95.38 71.17 115.22 64 108"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "64 108 53.83 95.38 49.36 95.38 56.83 115.22 64 108"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M81.72,98.25a3.06,3.06,0,0,0-3.08-2.88H74.17L64,108,53.83,95.37H49.36a3.06,3.06,0,0,0-3.08,2.92c0,.11,0,.21,0,.32-.17,7.32,10.52,16.64,10.52,16.64L64,108.05l7.17,7.17s10.56-9,10.56-16.22C81.73,98.74,81.73,98.49,81.72,98.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar6);
export default __webpack_public_path__ + "static/media/avatar6.323ec3369bd113777fd9d7aa0df243d0.svg";
export { ForwardRef as ReactComponent };